import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useCrewDefinitions() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Computed */
	// The route is gated on `read Plan`, so the query has to agree with the gate or the request
	// still goes out behind a hidden panel and toasts a 403. Rules still loading leave it enabled,
	// so the server keeps the last word.
	const canRead = citadel ? citadel.can("read", "Plan") : true;

	/** Query */
	const query = useQuery({
		queryKey: ["crew-definitions"],
		queryFn: async () => {
			const response = await client.crew_definitions.index.$get();
			const data = await responseHandler(response);
			return data.crewDefinitions;
		},
		enabled: canRead,
	});

	/** Return */
	return { ...query, crewDefinitions: guardArray(query.data) };
}

export type CrewDefinitionList = ReturnType<typeof useCrewDefinitions>["crewDefinitions"];
export type CrewDefinitionListItem = CrewDefinitionList[number];
